import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

import {
  IConfirmMoveDevicesFromModal,
  IConfirmMoveSingleDeviceFromModal,
  IMovingDevice,
  IPlacedDevice,
  IRemovedDeviceFromSwitchboard
} from '../../../enclosure/models/grid.model';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-var
declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-feeding-tree-conflict-modal',
    templateUrl: './feeding-tree-conflict-modal.component.html',
    styleUrls: ['./feeding-tree-conflict-modal.component.scss'],
    standalone: false
})
export class FeedingTreeConflictModalComponent {
  previousDevice: IMovingDevice;
  previousMultipleDevices: IMovingDevice[];
  newDevice: IPlacedDevice;
  removedDevices: IRemovedDeviceFromSwitchboard[];
  newAddedDevices: IPlacedDevice[];
  newMultipleDevices: IPlacedDevice[];

  @ViewChild('feedingTreeConflictModalWindow') feedingTreeModal: ElementRef;

  @Output() confirmSelection = new EventEmitter<IConfirmMoveSingleDeviceFromModal>();
  @Output() confirmRemoveDevices = new EventEmitter<IRemovedDeviceFromSwitchboard[]>();
  @Output() confirmMultipleDevicesDragSelection = new EventEmitter<IConfirmMoveDevicesFromModal>();
  @Output() confirmAddingNewDevices = new EventEmitter<IPlacedDevice[]>();
  @Output() cancelMovingDevice = new EventEmitter<IMovingDevice>();
  @Output() cancelMovingMultipleDevices = new EventEmitter<IMovingDevice[]>();
  @Output() cancelDeletingDevices = new EventEmitter<IRemovedDeviceFromSwitchboard[]>();
  @Output() cancelAddingNewDevices = new EventEmitter<IPlacedDevice[]>();

  onConfirm() {
    if (this.previousDevice || this.newDevice) {
      this.confirmSelection.emit({ deviceWithNewPosition: this.newDevice, previousDevice: this.previousDevice });
    }
    if (this.removedDevices?.length) {
      this.confirmRemoveDevices.emit(this.removedDevices);
    }
    if (this.newMultipleDevices?.length) {
      this.confirmMultipleDevicesDragSelection.emit({
        previousDevices: this.previousMultipleDevices,
        devicesWithNewPositions: this.newMultipleDevices
      });
    }
    if (this.newAddedDevices?.length) {
      this.confirmAddingNewDevices.emit(this.newAddedDevices);
    }
    this.resetState();
    this.closeModal();
  }

  cancelMove() {
    if (this.previousDevice || this.newDevice) {
      this.cancelMovingDevice.emit(this.previousDevice);
    }
    if (this.previousMultipleDevices?.length) {
      this.cancelMovingMultipleDevices.emit(this.previousMultipleDevices);
    }
    if (this.removedDevices?.length) {
      this.cancelDeletingDevices.emit(this.removedDevices)
    }
    if (this.newAddedDevices?.length) {
      this.cancelAddingNewDevices.emit(this.newAddedDevices);
    }
    this.resetState();
    this.closeModal();
  }

  closeModal() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.feedingTreeModal.nativeElement).modal('hide');
  }

  openModal(previousDevice: IMovingDevice, newDevice: IPlacedDevice) {
    this.previousDevice = previousDevice;
    this.newDevice = newDevice;
    jQuery(this.feedingTreeModal.nativeElement).modal('show');
  }

  openAddNewDevicesModal(newDevices: IPlacedDevice[]) {
    this.newAddedDevices = [].concat(newDevices)
    jQuery(this.feedingTreeModal.nativeElement).modal('show');
  }

  openModalMultipleDevicesDrag(previousDevices: IPlacedDevice[], newDevices: IPlacedDevice[]) {
    this.previousMultipleDevices = [].concat(previousDevices);
    this.newMultipleDevices = newDevices;
    jQuery(this.feedingTreeModal.nativeElement).modal('show');
  }

  openDeleteDeviceModal(removedDevice: IRemovedDeviceFromSwitchboard[]) {
    this.removedDevices = [].concat(removedDevice);
    jQuery(this.feedingTreeModal.nativeElement).modal('show');
  }

  resetState() {
    this.previousDevice = null;
    this.previousMultipleDevices = [];
    this.newDevice = null;
    this.removedDevices = [];
    this.newMultipleDevices = [];
    this.newAddedDevices = [];
  }

}
